module.exports = __webpack_public_path__ + "img/国家体育总局@2x.0621a7fc.png";